// extracted by mini-css-extract-plugin
export var actionButton = "_ix-t";
export var buttonContainer = "_ix-0";
export var buttonContainer2 = "_ix-1";
export var buttonSection = "_ix-2";
export var details = "_ix-3";
export var dropdownItem = "_ix-5";
export var dropdownItemsContainer = "_ix-4";
export var fileInput = "_ix-r";
export var headerButton = "_ix-6";
export var icon = "_ix-7";
export var input = "_ix-8";
export var macroListItem = "_ix-9";
export var mainContent = "_ix-a";
export var microText = "_ix-b";
export var modal = "_ix-w";
export var optionsButton = "_ix-c";
export var paperclip = "_ix-s";
export var pillContent = "_ix-d";
export var preview = "_ix-e";
export var preview2 = "_ix-f";
export var quillEditor = "_ix-q";
export var selectedMacro = "_ix-g";
export var sidebar = "_ix-h";
export var sidebarHeader = "_ix-j";
export var sidebarList = "_ix-i";
export var sidebarListItem = "_ix-k";
export var sidebarSearch = "_ix-l";
export var snoozeDurationWrapper = "_ix-v";
export var statusPillContainer = "_ix-m";
export var tagsContainer = "_ix-n";
export var unselectedMacro = "_ix-o";
export var variable = "_ix-u";
export var wrapper = "_ix-p";